import React from 'react';
import { AdvancedRealTimeChart } from 'react-ts-tradingview-widgets';

type Props = { baseCurrency: string; exchangeCurrency: string };

export const CurrencyExchangeRateWidget = ({ baseCurrency, exchangeCurrency }: Props) => {
    return <AdvancedRealTimeChart autosize symbol={`${baseCurrency}${exchangeCurrency}`} />;
};
